import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './portfoliocarousel.css'; // Import CSS file for styling

const PortfolioCarousel = ({ projects }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <div className="portfolio-carousel">
              <h2>Take a Look at My Projects</h2>
      <Slider {...settings}>
        {projects.map(project => (
          <div key={project.id}>
            <div className="carousel-item">
              <img src={project.image} alt={project.name} />
              <div className="carousel-item-info">
                <h3>{project.name}</h3>
                <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-btn">
                  <i className="fas fa-globe"></i> View Project
                </a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default PortfolioCarousel;